import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";

const BenefitCard = ({ benefit }) => (
  <Box
    bg="white"
    borderRadius="xl"
    p={6}
    border="1px"
    borderColor="gray.200"
    shadow="sm"
    h="full"
    // minH="160px"
    w="full"
    display="flex"
    flexDirection="column"
    justifyContent="center"
    transition="all 0.3s ease"
    _hover={{
      shadow: "md",
      transform: "translateY(-2px)",
      borderColor: "blue.200",
    }}
  >
    <VStack align="start" spacing={2}>
      <Heading size="sm" color="#000B8C" fontWeight="normal" align="start">
        {benefit.title}
      </Heading>
      <Text color="gray.600" fontSize="sm" lineHeight="1.6" align="start">
        {benefit.description}
      </Text>
    </VStack>
  </Box>
);

export default BenefitCard;